<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Seguro/Garantia
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirSeguro"
			hide-footer
		>
			<div slot="modal-title">
				Seguros/Garantias -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<seguros-form
				tipoOperacao="i"
				:showModal="showModal"
				:contrato="contrato"
				@modalFechado="showModal = false"
				@obterSegurosAtualizados="$emit('obterSegurosAtualizados')"
			></seguros-form>
		</b-modal>
    </div>
</template>

<script>
import SegurosForm from './SegurosForm'

export default {
	components: {
		SegurosForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
